"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitPaymentWithoutDetails = exports.paymentSlice = exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toolkit = require("@reduxjs/toolkit");
var _api = require("../api");
var _extraReducers;
var initialState = {
  loading: false,
  error: null
};
var submitPaymentWithoutDetails = (0, _toolkit.createAsyncThunk)('payment/submitPaymentWithoutDetails', /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_, _ref) {
    var rejectWithValue, payment;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          rejectWithValue = _ref.rejectWithValue;
          _context.prev = 1;
          _context.next = 4;
          return (0, _api.submitPaymentWithoutDetails)();
        case 4:
          payment = _context.sent;
          return _context.abrupt("return", payment);
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](1);
          return _context.abrupt("return", rejectWithValue(_context.t0.message));
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 8]]);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
exports.submitPaymentWithoutDetails = submitPaymentWithoutDetails;
var paymentSlice = (0, _toolkit.createSlice)({
  name: 'paymentSlice',
  initialState: initialState,
  reducers: {},
  extraReducers: (_extraReducers = {}, (0, _defineProperty2.default)(_extraReducers, submitPaymentWithoutDetails.pending, function (state) {
    state.loading = true;
  }), (0, _defineProperty2.default)(_extraReducers, submitPaymentWithoutDetails.fulfilled, function (state) {
    state.loading = false;
  }), (0, _defineProperty2.default)(_extraReducers, submitPaymentWithoutDetails.rejected, function (state, _ref3) {
    var payload = _ref3.payload;
    state.loading = false;
    if (payload.includes("Order doesn't have paymentMethodId")) {
      state.error = 'Unable to proceed, because of wrong offer settings. Please, contact the owner of the offer';
    } else {
      state.error = 'Oops, something went wrong! Please, reload the page and try again';
    }
  }), _extraReducers)
});
exports.paymentSlice = paymentSlice;
var _default = paymentSlice.reducer;
exports.default = _default;